"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageContentType = exports.MessageContent = void 0;
var MessageContent;
(function (MessageContent) {
    let Message;
    (function (Message) {
        Message.Type = {
            Text: 'text',
            Upload: 'upload',
            RateForm: 'rate_form',
            TicketForm: 'ticket_form',
        };
    })(Message = MessageContent.Message || (MessageContent.Message = {}));
    let Event;
    (function (Event) {
        Event.Type = {
            AgentJoin: 'agent_join',
            AgentAssign: 'agent_assign',
            AgentUnassign: 'agent_unassign',
            AgentLeave: 'agent_leave',
            ChatClose: 'chat_close',
            ChatVisitorClose: 'chat_visitor_close',
        };
    })(Event = MessageContent.Event || (MessageContent.Event = {}));
    let Help;
    (function (Help) {
        Help.Type = {
            Text: 'text',
            FoundEmail: 'found_email',
        };
    })(Help = MessageContent.Help || (MessageContent.Help = {}));
})(MessageContent = exports.MessageContent || (exports.MessageContent = {}));
exports.MessageContentType = {
    ...MessageContent.Message.Type,
    ...MessageContent.Event.Type,
    ...MessageContent.Help.Type,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnZS1jb250ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL21lc3NhZ2UtY29udGVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFXQSxJQUFpQixjQUFjLENBd0o5QjtBQXhKRCxXQUFpQixjQUFjO0lBUTlCLElBQWlCLE9BQU8sQ0EwQ3ZCO0lBMUNELFdBQWlCLE9BQU87UUFDVixZQUFJLEdBQUc7WUFDbkIsSUFBSSxFQUFFLE1BQU07WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixRQUFRLEVBQUUsV0FBVztZQUNyQixVQUFVLEVBQUUsYUFBYTtTQUNoQixDQUFBO0lBb0NYLENBQUMsRUExQ2dCLE9BQU8sR0FBUCxzQkFBTyxLQUFQLHNCQUFPLFFBMEN2QjtJQVdELElBQWlCLEtBQUssQ0EyRHJCO0lBM0RELFdBQWlCLEtBQUs7UUFDUixVQUFJLEdBQUc7WUFDbkIsU0FBUyxFQUFFLFlBQVk7WUFDdkIsV0FBVyxFQUFFLGNBQWM7WUFDM0IsYUFBYSxFQUFFLGdCQUFnQjtZQUMvQixVQUFVLEVBQUUsYUFBYTtZQUN6QixTQUFTLEVBQUUsWUFBWTtZQUN2QixnQkFBZ0IsRUFBRSxvQkFBb0I7U0FDN0IsQ0FBQTtJQW1EWCxDQUFDLEVBM0RnQixLQUFLLEdBQUwsb0JBQUssS0FBTCxvQkFBSyxRQTJEckI7SUFPRCxJQUFpQixJQUFJLENBd0JwQjtJQXhCRCxXQUFpQixJQUFJO1FBQ1AsU0FBSSxHQUFHO1lBQ25CLElBQUksRUFBRSxNQUFNO1lBQ1osVUFBVSxFQUFFLGFBQWE7U0FDaEIsQ0FBQTtJQW9CWCxDQUFDLEVBeEJnQixJQUFJLEdBQUosbUJBQUksS0FBSixtQkFBSSxRQXdCcEI7QUFDRixDQUFDLEVBeEpnQixjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQXdKOUI7QUFPWSxRQUFBLGtCQUFrQixHQUFHO0lBQ2pDLEdBQUcsY0FBYyxDQUFDLE9BQU8sQ0FBQyxJQUFJO0lBQzlCLEdBQUcsY0FBYyxDQUFDLEtBQUssQ0FBQyxJQUFJO0lBQzVCLEdBQUcsY0FBYyxDQUFDLElBQUksQ0FBQyxJQUFJO0NBQ2xCLENBQUEifQ==